<template>
  <div
    v-if="entity"
    class="table-row-wrapper"
  >
    <div class="table-row">
      <div class="table-cell table-cell-sticky">
        <div
          v-if="selectable"
          class="form-check form-master-check mt-0 mb-0 pl-0"
        >
          <b-form-checkbox
            v-model="entity.selected"
            @change="selectEntity(entity)"
          />
        </div>
      </div>
      <div
        class="table-cell table-cell-title table-cell-sticky"
        :class="getPaddingClass(level)"
        :style="{width: titlewidth + 'px'}"
      >
        <span
          v-if="entity.entityType < 3 && !selectable && entity.children.length > 0"
          class="arrow-icon position-absolute"
        >
          <b-button
            v-if="entity.showChildren"
            size="sm"
            variant="link"
            class="secondary"
            @click="setShowChildren(entity, false)"
          >
            <GjIcon
              key="childrenDowm"
              name="ArrowDown"
            />
          </b-button>
          <b-button
            v-else
            size="sm"
            variant="link"
            class="secondary"
            @click="setShowChildren(entity, true)"
          >
            <GjIcon
              key="childrenRight"
              name="ArrowRight"
            />
          </b-button>
        </span>
        <span v-else-if="entity.entityType < 4 && selectable && entity.breakdowns.length > 0">
          <b-button
            v-if="!entity.hideBreakdown"
            size="sm"
            variant="link"
            class="secondary p-0"
            @click="setHideBreakdown(entity, true)"
          >
            <GjIcon
              key="breakdownDown"
              name="ArrowDown"
            />
          </b-button>
          <b-button
            v-else
            size="sm"
            variant="link"
            class="secondary p-0"
            @click="setHideBreakdown(entity,false)"
          >
            <GjIcon
              key="breakdownRight"
              name="ArrowRight"
            />
          </b-button>
        </span>
        <b-card
          v-if="tab==='Ads'"
          class="border m-0 d-inline-block align-top"
          body-class="p-0 h-100"
          :class="!entity.mediaUrl ? '' : 'cursor-pointer'"
        >
          <img
            v-if="!entity.mediaUrl || entity.entityAdSubtype === 'External'"
            src="@/assets/icons/image-preview.png"
            alt="Image Preview"
          >
          <div
            v-else
            :id="`image-popover-${entity.id}`"
            :key="`Image-${entity.name}`"
            class="ad-image text-center mx-auto"
            :style="{ backgroundImage: 'url(' + entity.mediaUrl + ')' }"
            @click="openAdImagePreview"
          />
          <b-popover
            :target="`image-popover-${entity.id}`"
            triggers="hover"
            placement="bottom"
          >
            <b-card
              class="border m-0"
              body-class="p-0 h-100"
            >
              <iframe
                v-if="entity.entityAdSubtype === 'Html'"
                :src="entity.mediaUrl"
                :height="100"
                :width="250"
                frameborder="0"
                scrolling="auto"
              />
              <video
                v-else-if="entity.entityAdType === 'Video'"
                width="200"
                height="100"
                autoplay
                muted
              >
                <source
                  :src="entity.videoUrl"
                  type="video/mp4"
                >
              </video>
              <div
                v-else
                :id="`image-popover-${entity.id}`"
                :key="`Image-${entity.name}`"
                class="ad-image-popover text-center mx-auto"
                :style="{ backgroundImage: 'url(' + entity.mediaUrl + ')' }"
              />
            </b-card>
          </b-popover>
        </b-card>
        <GjIcon
          v-else-if="entity.entityIcon"
          :name="getIcon(entity.entityIcon)"
          class="align-top"
        />
        <div
          class="eclipsis"
          :class="entity.entityType < 4 && selectable && entity.breakdowns.length > 0 ? 'entity-name-breakdown ml-50' : 'entity-name ml-1'"
          @click="clickEntity(entity)"
        >
          {{ entity.name }}
        </div>
        <div class="d-inline-flex">
          <b-button
            v-if="entity.editable"
            v-b-tooltip.hover
            v-b-toggle="'edit-campaign-modal-'+entity.id"
            size="sm"
            variant="link"
            class="text-secondary px-0"
            :title="$tk('ClientPortal.Form.Actions.Edit')"
            @click="editModal.show = true"
          >
            <GjIcon
              key="entityEdit"
              class="hover-button"
              name="Edit"
            />
          </b-button>
          <b-button
            v-if="entity.editable"
            v-b-tooltip.hover
            size="sm"
            variant="link"
            class="text-secondary px-0"
            :title="$tk('ClientPortal.Form.Actions.Duplicate')"
            @click="openCopyModal(entity)"
          >
            <GjIcon
              key="entityCopy"
              class="hover-button"
              name="Copy"
            />
          </b-button>
          <b-button
            v-if="entity.entityAdType == 'Display' && entity.entityType == 3 && entity.entityAdSubtype !=='Video outstream'"
            :id="'edit-modal-small-'+entity.id"
            v-b-tooltip.hover
            size="sm"
            variant="link"
            class="text-secondary px-0"
            :title="$tk('ClientPortal.MasterTable.Heatmap')"
            @click="openHeatmapModal(entity)"
          >
            <GjIcon

              key="entityHeatmap"
              class="hover-button"
              name="MenuAlt3"
            />
          </b-button>
        </div>
      </div>
      <div
        v-for="(presetColumnKey, index) in preset.columns"
        :id="'table-cell-'+entity.id+'-'+index+':'+tab"
        :key="index"
        class="table-cell"
        :class="customColumnClass(presetColumnKey)"
      >
        <b-button
          v-if="isEditable(entity, presetColumnKey)"
          :id="'edit-modal-small-'+entity.id+'-'+index+':'+tab"
          :key="'edit-button-'+entity.id+index"
          size="sm"
          variant="link"
          class="text-secondary px-0"
          @click="openQuickEditModal(entity, presetColumnKey, $event)"
        >
          <GjIcon
            key="entityEdit"
            class="hover-button"
            name="Edit"
          />
        </b-button>
        <b-popover
          v-if="isEditable(entity, presetColumnKey)"
          ref="modalSmallOverlay"
          :target="'edit-modal-small-'+entity.id+'-'+index+':'+tab"
          triggers="focus"
        >
          <div class="form-group edit-modal-small mb-0">
            <label>
              <b>{{ editModal.label }}</b>
            </label>
            <div
              v-if="editModal.inputType == 5"
              class="editModal-value change-text"
            >
              <input
                id="edit-modal-value"
                v-model="editModal.value"
                type="number"
                class="form-control form-control-sm"
                min="1"
                @keyup.enter="saveQuickEditModal(editModal, entity)"
              >
            </div>
            <div
              v-else-if="editModal.inputType == 3"
              class="editModal-value change-status"
            >
              <v-select
                v-model="editModal.value"
                :clearable="false"
                label="title"
                class="smaller-indicator"
                :close-on-select="false"
                :placeholder="$tk('ClientPortal.AdGroup.ChooseStatus')"
                :options="statuses.filter(status => status.editable === true)"
                :reduce="status => status.id"
                @input="focusSaveButton"
              />
            </div>
            <div
              v-else-if="editModal.inputType == 4"
              class="editModal-value change-datetime"
            >
              <vuejs-datepicker
                v-model="editModal.value"
                bootstrap-styling
                :inline="true"
                :use-u-t-c="false"
                :format="customFormatter"
              />
            </div>
            <div
              class="text-right mt-50"
            >
              <b-button
                variant="outline-dark"
                size="sm"
                @click="hidePopover('edit-modal-small-'+entity.id+'-'+index+':'+tab)"
              >
                {{ $tk('ClientPortal.MasterTable.Cancel') }}
              </b-button>
              <b-button
                id="saveBtn"
                variant="primary"
                size="sm"
                class="ml-50"
                @click="saveQuickEditModal(editModal, entity)"
              >
                {{ $tk('ClientPortal.MasterTable.Save') }}
              </b-button>
            </div>
          </div>
        </b-popover>
        <span
          class="eclipsis"
          :class="presetColumnKey == 'status' ? getStatusColorType(entity.statusId) : ''"
        >
          {{ entity[presetColumnKey] | formatValue(columns[presetColumnKey]) }}
        </span>
      </div>
    </div>
    <template v-for="child in entity.children">
      <master-table-row
        v-if="entity.showChildren && !selectable"
        :key="child.entityType + '-' + child.id"
        :entity="child"
        :preset="preset"
        :level="level + 1"
        :parent-id="entity.id"
        :columns="columns"
        :selectable="selectable"
        :statuses="statuses"
        :titlewidth="titlewidth"
        :has-breakdown-items="entity.breakdowns.length > 0"
        @copy="openCopyModal"
        @edit="openEditModal"
        @heatmap="openHeatmapModal"
      />
    </template>
    <template v-for="(breakdown, index) in entity.breakdowns">
      <master-table-row
        v-if="!entity.hideBreakdown && selectable"
        :key="'breakdown-' + breakdown.entityType + '-' + index + '-' + breakdown.id"
        :entity="breakdown"
        :preset="preset"
        :level="level + 1"
        :columns="columns"
        :selectable="selectable"
        :statuses="statuses"
        :titlewidth="titlewidth"
        @copy="openCopyModal"
        @edit="openEditModal"
        @heatmap="openHeatmapModal"
      />
    </template>
    <!--SIDEBAR FOR EDIT-->
    <b-sidebar
      v-if="editModal.show"
      :id="'edit-campaign-modal-'+entity.id"
      ref="editSidebarModal"
      backdrop-variant="transparent"
      backdrop
      shadow="lg"
      right
      width="740px"
      class="px-50"
      :no-header-close="true"
      @hidden="closeEditModal"
    >
      <div
        v-if="editModal.show"
        class="px-1"
      >
        <campaign-edit
          v-if="openCampaignEditComponent"
          :id="entity.id"
          :height-offset="'97px'"
          :entity="entity"
        />
        <ad-group-edit
          v-if="openAdGroupEditComponent"
          :ad-group-id="entity.id"
          :height-offset="'97px'"
          :entity="entity"
        />
        <ad-edit
          v-if="openAdEditComponent"
          :ad-id="entity.id"
          :ad-group-id="parentId"
          :entity="entity"
        />
      </div>
    </b-sidebar>
    <!-- Modal for ad image preview -->
    <ad-image-preview-modal
      ref="adImagePreview"
      :ad="entity"
    />
  </div>
</template>

<script>
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import notifications from '@/mixins/toastification'
import CampaignEdit from '@/views/client/ads-manager/create/Campaign.vue'
import AdGroupEdit from '@/views/client/ads-manager/create/AdGroup.vue'
import AdEdit from '@/views/client/ads-manager/create/ads/Ad.vue'
import StatisticsService from '@/api/client/statistics.service'
import AdImagePreviewModal from '@/components/AdImagePreviewModal.vue'
import vSelect from 'vue-select'
import { formatCurrency } from '@/utils/currency'

const ENTITY_TYPES = {
  CAMPAIGN: 1,
  AD_GROUP: 2,
  AD: 3,
  BREAKDOWN: 4,
  SUMMARY: 5,
}

const CAMPAIGN_STATUSES = {
  ACTIVE: 1,
  INACTIVE: 2,
  SCHEDULED: 9,
  EXPIRED: 10,
  DAILY_BUDGET_SPENT: 6,
  TARGET_GOAL_REACHED: 14,
}

export default {
  name: 'MasterTableRow',
  components: {
    vuejsDatepicker,
    GjIcon,
    CampaignEdit,
    AdGroupEdit,
    AdEdit,
    AdImagePreviewModal,
    vSelect,
  },
  filters: {
    formatValue(value, columnType) {
      if (value === 0) {
        return '-'
      }
      const amt = Number(value)
      if (columnType.inputType === 5) {
        return formatCurrency(amt)
      } if (columnType.inputType === 6) {
        return `${(amt && amt.toLocaleString(undefined, { maximumFractionDigits: 2 })) || '0'} %`
      } if (columnType.inputType === 2) {
        return ((amt && amt.toLocaleString(undefined, { maximumFractionDigits: 2 })) || '0')
      }
      return value
    },
  },
  mixins: [notifications],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    entity: Object,
    // eslint-disable-next-line vue/require-default-prop
    preset: Object,
    // eslint-disable-next-line vue/require-default-prop
    level: Number,
    // eslint-disable-next-line vue/require-default-prop
    columns: Object,
    selectable: {
      type: Boolean,
      default: false,
    },
    hasBreakdownItems: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    statuses: Array,
    // eslint-disable-next-line vue/require-default-prop
    titlewidth: Number,
    parentId: {
      type: Number,
      default: 0,
    },
    tab: {
      type: String,
      default: 'Campaign',
    },
  },
  data() {
    return {
      checked: this.selected,
      editModal: {
        top: 0,
        left: 0,
        show: false,
        entityType: 0,
        inputType: 0,
        id: 0,
        label: '',
        property: '',
        value: '',
      },
      // sidebarOpen: false,
    }
  },
  computed: {
    openCampaignEditComponent() {
      return this.entity.entityType === ENTITY_TYPES.CAMPAIGN
    },
    openAdGroupEditComponent() {
      return this.entity.entityType === ENTITY_TYPES.AD_GROUP
    },
    openAdEditComponent() {
      return this.entity.entityType === ENTITY_TYPES.AD
    },
    getTitle() {
      if (this.entity.entityType === ENTITY_TYPES.CAMPAIGN) { return 'Campaign' }
      if (this.entity.entityType === ENTITY_TYPES.AD_GROUP) { return 'AdGroup' }
      if (this.entity.entityType === ENTITY_TYPES.AD) { return 'Ad' }
      return ''
    },
  },
  provide() {
    return {
      closeEditModal: this.closeEditModal,
    }
  },
  methods: {
    focusSaveButton() {
      document.getElementById('saveBtn').focus()
    },
    getPaddingClass(level) {
      return `indent-pl-${level}`
    },
    getStatusColorType(status) {
      if (status === CAMPAIGN_STATUSES.ACTIVE) { return 'text-success' }
      if (status === CAMPAIGN_STATUSES.INACTIVE) { return 'text-danger' }
      if (status === CAMPAIGN_STATUSES.SCHEDULED) { return 'text-warning' }
      if (status === CAMPAIGN_STATUSES.EXPIRED) { return 'text-dark' }
      if (status === CAMPAIGN_STATUSES.DAILY_BUDGET_SPENT) { return 'text-info' }
      if (status === CAMPAIGN_STATUSES.TARGET_GOAL_REACHED) { return 'text-info' }
      return 'text-primary'
    },
    isEditable(entity, columnKey) {
      if (!entity.editable) {
        return false
      }
      const column = this.columns[columnKey]
      return column.editableTypes.indexOf(entity.entityType) > -1
    },
    showEditIcons(entityType) {
      return this.editable && entityType < 4
    },
    getStatusColor(columnKey, entity) {
      if (!this.statuses) {
        return
      }
      const column = this.columns[columnKey]
      if (column.inputType === 3) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.statuses.length; i++) {
          if (entity.statusId === this.statuses[i].id) {
            // eslint-disable-next-line consistent-return
            return this.statuses[i].icon
          }
        }
      }
    },
    customColumnClass(columnKey) {
      const column = this.columns[columnKey]
      if (column.inputType === 4) {
        return 'table-cell-text'
      }
      if (column.inputType === 3) {
        return 'table-cell-status'
      }
      if (column.inputType === 5) {
        return ''
      }
      return ''
    },
    customFormatter(date) {
      return moment(date).format('DD-MM-YYYY')
    },
    setShowChildren(entity, value) {
      this.$set(entity, 'showChildren', value)
    },
    setHideBreakdown(entity, value) {
      this.$set(entity, 'hideBreakdown', value)
    },
    closeEditModal() {
      const { editModal } = this

      editModal.left = 0
      editModal.top = 0
      editModal.entityType = 0
      editModal.label = ''
      editModal.property = ''
      editModal.value = ''
      editModal.show = false
    },
    openQuickEditModal(entity, columnKey, event) {
      if (columnKey !== 'name') {
        const { editModal } = this
        const column = this.columns[columnKey]

        editModal.left = event.clientX
        editModal.top = event.clientY

        if ((editModal.left + 348) > window.innerWidth) {
          editModal.left -= ((editModal.left + 348) - window.innerWidth)
        }

        if ((editModal.top + 157) > window.innerHeight) {
          editModal.top -= ((editModal.top + 157) - window.innerHeight)
        }

        if (columnKey === 'startDate' || columnKey === 'endDate') {
          if ((editModal.top + 400) > window.innerHeight) {
            editModal.top -= ((editModal.top + 400) - window.innerHeight)
          }
        }

        editModal.entityType = entity.entityType
        editModal.id = entity.id
        editModal.label = column.name
        editModal.property = column.property
        editModal.value = entity[column.property]
        editModal.inputType = column.inputType
        editModal.show = true
        if (column.inputType === 4) {
          if (editModal.value != null) {
            const dateMomentObject = moment(editModal.value, 'DD/MM/YYYY')
            const dateObject = dateMomentObject.toDate()
            editModal.value = dateObject
          }
        } else if (column.inputType === 3 && editModal.value !== 'Active') {
          editModal.value = 'Inactive'
        }
      }
    },
    openCopyModal(entity) {
      this.$emit('copy', entity)
    },
    openHeatmapModal(entity) {
      this.$emit('heatmap', entity)
    },
    selectEntity(entity) {
      this.$emit('select', entity)
    },
    clickEntity(entity) {
      if (!this.selectable) {
        this.setShowChildren(true)
      } else {
        entity.selected = true
        this.$emit('click', entity)
      }
    },
    saveQuickEditModal(editModal, entity) {
      this.saveQuickEditValue(editModal, entity)
      editModal.show = false
      this.$root.$emit('bv::hide::popover')
    },
    async saveQuickEditValue(editModal, entity) {
      if (editModal.property === 'startDate') {
        editModal.value = editModal.value.toString()
      } else if (editModal.property === 'endDate') { editModal.value = editModal.value.toString() }

      try {
        const data = await StatisticsService.updateValue(editModal, this.$route.params.accountId)
        if (data.saved) {
          this.success(data.message)
          entity[editModal.property] = data.editedValue
          if (editModal.property === 'status') {
            entity.statusId = data.statusId
          } else if (editModal.property === 'startDate') {
            entity.statusId = data.statusId
            entity.status = data.status
            entity.startDate = data.editedValue
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < entity.children.length; i++) {
              entity.children[i].startDate = entity.startDate
              // eslint-disable-next-line no-plusplus
              for (let j = 0; j < entity.children[i].children.length; j++) {
                entity.children[i].children[j].startDate = entity.startDate
              }
            }
          } else if (editModal.property === 'endDate') {
            entity.statusId = data.statusId
            entity.status = data.status
            entity.endDate = data.editedValue
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < entity.children.length; i++) {
              entity.children[i].endDate = entity.endDate
              // eslint-disable-next-line no-plusplus
              for (let j = 0; j < entity.children[i].children.length; j++) {
                entity.children[i].children[j].endDate = entity.endDate
              }
            }
          }
        } else {
          this.error(data.message)
        }
      } catch (error) {
        this.error(error.message)
      }
    },
    hidePopover(id) {
      this.$root.$emit('bv::hide::popover', id)
    },
    getIcon(icon) {
      switch (icon) {
        case 'mdi-monitor':
          return 'MonitorScreenDevice'
        case 'mdi-responsive':
          return 'MonitorScreenDevices'
        case 'mdi-play-box-outline':
          return 'VideoPlayer'
        case 'mdi-language':
          return 'Language'
        default:
          return 'BoxStorageArchive'
      }
    },
    openAdImagePreview() {
      this.$refs.adImagePreview.previewAdImage()
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/views/client/ads-manager/statistics/master-table-row.scss';
</style>
